import { motion } from "framer-motion";
import { useLanguage } from "../i18n/LanguageContext";

export const StatBar = () => {
  const { t, lang } = useLanguage();

  return (
    <section data-testid="stat-bar" className="relative">
      <div className="mx-auto grid max-w-[1500px] grid-cols-1 sm:grid-cols-3">
        {t.stats.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 44, scale: 0.92 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ type: "spring", stiffness: 160, damping: 15, delay: i * 0.12 }}
            whileHover={{ y: -6 }}
            data-testid={`stat-${i}`}
            className={`group relative border-t border-teal-500/10 px-6 py-12 sm:border-t-0 sm:px-10 sm:py-16 lg:py-20 ${
              i === 1 ? "bg-teal-400/[0.04] sm:border-x sm:border-teal-500/15" : ""
            }`}
          >
            <span className="font-mono text-[10px] font-bold uppercase tracking-[0.3em] text-teal-400/60">
              0{i + 1}
            </span>
            <p
              className={`font-display mt-4 text-6xl font-extrabold tabular-nums transition-all duration-300 group-hover:text-[#00F5D4] sm:text-7xl lg:text-8xl ${
                i === 1 ? "text-teal-300 [text-shadow:0_0_40px_rgba(0,245,212,0.35)]" : "text-white"
              }`}
            >
              {s.v}
            </p>
            <p className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-slate-400 sm:text-sm">
              {s.l[lang]}
            </p>
          </motion.div>
        ))}
      </div>
      <div className="flex items-center justify-center gap-2 border-t border-teal-500/10 py-2.5">
        <span className="relative flex h-2 w-2">
          <span className="ping-slow absolute inline-flex h-full w-full rounded-full bg-teal-400" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-teal-300" />
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500" data-testid="stat-live">
          {t.statsLive[lang]}
        </span>
      </div>
    </section>
  );
};
